$(function () {
    // Initialise placement date pickers
    $('#placement-start-date').datetimepicker({
        dayOfWeekStart: 1,
        format: 'Y-m-d',
        timepicker: false,
    });

    $('#placement-end-date').datetimepicker({
        dayOfWeekStart: 1,
        format: 'Y-m-d',
        timepicker: false,
        onShow: function () {
            var startDateValue = $('#placement-start-date').val();
            if (startDateValue) {
                // Add one day to prevent selecting the same date
                var minDate = dayjs(startDateValue).add(1, 'day').format('YYYY-MM-DD');
                this.setOptions({ minDate: minDate });
            } else {
                this.setOptions({ minDate: false });
            }
        },
    });

    function updateUrlWithDates() {
        const startDate     = $('#placement-start-date').val();
        const endDate       = $('#placement-end-date').val();
        const academicYear  = $('ul.flt_acyr li.active').text().trim();
        const programmeYear = $('ul.flt_programme_year li.active').text().trim();
        const published     = $('ul.flt_published li.active').find('a').data('published');

        const currentUrl   = window.location.href;
        const baseSegments = currentUrl.split('/');
        const baseUrl      = baseSegments.slice(0, currentUrl.split('/').indexOf('studentplacements') + 1).join('/');

        if (endDate && dayjs(endDate, 'YYYY-MM-DD', true).isValid()) {
            window.location.assign(baseUrl + '/' + academicYear + '/' + programmeYear + '/' + published + '/' + startDate + '/' + endDate);
        } else {
            window.location.assign(baseUrl + '/' + academicYear + '/' + programmeYear + '/' + published + '/' + startDate);
        }
    }

    // Redirect on date selection
    $('#placement-start-date, #placement-end-date').on('change', updateUrlWithDates);

    // Reset button
    $('#placement-day-filter').on('click', function () {
        $('#placement-start-date, #placement-end-date').val('');
    });

    $('#download-placements').on('click', function (event) {
        event.preventDefault();

        var currentUrl = window.location.href;

        // Replace 'studentplacements' with 'downloadExcel'
        var newUrl = currentUrl.replace('studentplacements', 'download-excel');

        window.location.assign(newUrl);
    });
});
